import _ from 'lodash'

function quoteSpace(value) {

    if (typeof(value) !== 'string') {
        return value
    }

    if (value.startsWith("'") && value.endsWith("'")) {
        return value;
    }
    if (value.includes(' ')) {
        return "'" + value + "'"
    }
    return value;
}

export default {
    buildQueryString (names, values, wildcards) {

        if (names.length !== values.length) {
            return ''
        }

        let qs = ''
        let index = 0
        _.each(values, (value) => {
            if (value || (value === 0) || (value === false)) {
                const name = names[index]
                if (qs) {
                    qs = qs + '&'
                }
                if (wildcards.includes(name)) {
                    if (value.includes('*')) {
                        qs = qs + name + '=' + quoteSpace(value)
                    } else {
                        qs = qs + name + '=' + quoteSpace('*' + value + '*')
                    }
                } else {
                    qs = qs + name + '=' + quoteSpace(value)
                }
            }
            index++
        })
        return qs
    },
    createPatchObject (oldVersion, newVersion) {

        let result = {id: oldVersion.id}

        _.forEach(oldVersion, (value, key) => {
            if (!_.isEqual(value, newVersion[key])) {
                result[key] = newVersion[key]
            }
        })

        let oldKeys = _.keys(oldVersion)
        _.forEach(newVersion, (value, key) => {
            if (!oldKeys.includes(key)) {
                result[key] = value
            }
        })

        return result
    }
}